export const de = {
    'ROLE_FILTER.LABEL': 'Rollen filtern',
    'ROLE_FILTER.SHOW_ALL': 'Alle Rollen anzeigen',
    'ROLE_FILTER.ELEVATED': 'Erweiterte Rollen',
    'ROLE_FILTER.ROLE_COUNT': '{[{ count }]} Rollen',
    'ROLE_FILTER.SELECT_ALL': 'Alle Rollen auswählen',
    'ROLE_FILTER.SELECT_ELEVATED': 'Erweiterte Rollen auswählen',
    'ROLE_FILTER.CLEAR': 'Auswahl aufheben',
    'ROLES.ADMIN': 'Admin',
    'ROLES.REPORTER': 'Reporter',
    'ROLES.VR_USER': 'VR Benutzer',
    'ROLES.EVENT_MANAGER': 'Eventmanager',
    'ROLES.EVENT_CURATOR': 'Eventkurator',
    'ROLES.BC_USER': 'BC Benutzer',
    'ROLES.BC_MANAGER': 'BC Manager',
    'ROLES.DA_USER': 'DA Benutzer',
    'ROLES.DA_MANAGER': 'DA Manager',
    'ROLES.LR_USER': 'LR Benutzer',
};
